import { Redirect, Route, Switch } from "react-router";

import Box from "@mui/material/Box";

import useCrew from "../../hooks/useCrew";
import NoActiveCrew from "../../components/NoActiveCrew";
import Sidebar from "../../features/sidebar";
import CrewPage from "../crew-page";
import Orders from "../orders";
import OrdersCrew from "../orders-crew";
import UploadBankFile from "../upload-bank-file";
import TransactionsBank from "../transactions-bank";
import Positions from "../positions";
import Operations from "../operations";
import UsersTable from "../../features/users-table";
import CrewsTable from "../../features/crews-table";
import Certificate from "../certificate";
import CoursesGroups from "../courses-groups";
import RelationsPage from "../relations";
import UserCompliance from "../../features/compliance";
import { OrderPaidFail, OrderPaidSuccess, OrderPaidSuccessUpdateFailed } from "../order-paid";
import Courses from "../courses";
import AllUserCertificates from "../../features/all-user-certificates";
import CrewSubscriptions from "../../features/crew-subscriptions";
import Bundles from "../bundles";
import Trainings from "../trainings";
import PassConditions from "../pass-conditions";
import Observable from "../observable";
import ProcessStep from "../process-step";
import ActivitiesTraining from "../activities-training";
import AssociateOperationProcessStep from "../associate-operation-process-step";
import AssociatePositionProcessStep from "../associate-position-process-step";
import TrainingUsers from "../training-users";
import RolesTree from "../../features/roles-tree";
import UserOverview from "../user-overview";
import UserTrainings from "../user-trainings";
import TrainerOverview from "../trainer-overview";
import TrainerTrainings from "../trainer-trainings";
import SystemTrainerTrainings from "../system-trainer-trainings";
import CrewTrainings from "../crew-trainings";
import CrewUsersTrainings from "../crew-users-trainings";
import InstructorTrainings from "../instructor-trainings";
import AssessorTrainings from "../assessor-trainings";
import CheckerTrainings from "../checker-trainings";
import LimitationsManagement from "../limitations-management";
import { WithPermission } from "../../components/Authorization";
import { PERMISSIONS } from "../../constants";

import "./index.scss";

const CrewOverview = ({ menuOpen, setMenuOpen }) => {
  const crew = useCrew();
  if (crew.crew.status !== "active") {
    return <NoActiveCrew />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        padding: "1rem 0rem 0 1rem",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        className={"sidebar-wrapper " + (menuOpen && "active")}
        sx={{
          flex: "0 0 22rem",
          marginRight: "3rem",
          overflow: "auto",
          paddingBottom: "10px",
        }}
      >
        <Sidebar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      </Box>
      <Box
        style={{
          paddingRight: "1rem",
          paddingBottom: "40px",
          overflow: "auto",
        }}
        sx={{
          flex: "1 1 auto",
          minHeight: 0,
        }}
      >
        <Switch>
          CrewOverview
          <Route path="/order-paid=0" component={OrderPaidFail} />
          <Route path="/order-paid=1" component={OrderPaidSuccess} />
          <Route path="/order-paid=2" component={OrderPaidSuccessUpdateFailed} />
          <Route path="/courses" component={Courses} />
          <Route path="/courses_groups" component={CoursesGroups} />
          <Route path="/trainings" component={Trainings} />
          <Route path="/pass-conditions" component={PassConditions} />
          <Route path="/observable" component={Observable} />
          <Route path="/process-step" component={ProcessStep} />
          <Route path="/activities-training" component={ActivitiesTraining} />
          <Route path="/associate-operation-process-step" component={AssociateOperationProcessStep} />
          <Route path="/associate-position-process-step" component={AssociatePositionProcessStep} />
          <Route path="/training-users/:trainingRole" component={TrainingUsers} />
          <Route path="/user-overview" component={UserOverview} />
          <Route path="/user-trainings" component={UserTrainings} />
          <Route path="/trainer-overview" component={TrainerOverview} />
          <Route path={["/crew-trainings/:crewId"]} component={CrewTrainings} />
          <Route path={["/crew-users-trainings/:crewId"]} component={CrewUsersTrainings} />
          <Route path="/trainer-trainings" component={TrainerTrainings} />
          <Route path="/system-trainer-trainings" component={SystemTrainerTrainings} />
          <Route path="/instructor-trainings" component={InstructorTrainings} />
          <Route path="/assessor-trainings" component={AssessorTrainings} />
          <Route path="/checker-trainings" component={CheckerTrainings} />
          <Route path={["/user/:userId/certificates", "/user/certificates"]} component={AllUserCertificates} />
          <Route path="/user/compliance/:pageId" component={UserCompliance} />
          <Route path={["/crew/:crewId/relations", "/relations"]} component={RelationsPage} />
          <Route path={["/crew/:crewId/roles", "/roles"]} component={RolesTree} />
          <Route
            path={["/crew/:crewId/limitations", "/limitations"]}
            render={(props) => (
              <WithPermission permission={PERMISSIONS.MANAGE_AIRCRAFT_OPERATIONS}>
                <LimitationsManagement {...props} />
              </WithPermission>
            )}
          />
          <Route path="/orders" component={Orders} />
          {/* The profile page moved to the Cockpit account page (CREW-598); old bookmarks land on the home page. */}
          <Redirect from="/user-profile" to="/" />
          <Route path="/upload-bank-file" component={UploadBankFile} />
          <Route path="/transactions-bank" component={TransactionsBank} />
          <Route path="/crew" component={CrewPage} />
          <Route path="/positions" component={Positions} />
          <Route path="/operations" component={Operations} />
          <Route path="/orders-crew" component={OrdersCrew} />
          <Route path="/crews" component={CrewsTable} />
          <Route path="/subscriptions" component={CrewSubscriptions} />
          <Route path="/users" component={UsersTable} />
          <Route path="/certificates" component={Certificate} />
          <Route path="/bundles" component={Bundles} />
          <Route exact path="/">
            <UserOverview />
          </Route>
        </Switch>
      </Box>
    </Box>
  );
};

export default CrewOverview;
